import {createReducer, on} from '@ngrx/store';
import { MemberFeesState } from '../../models/member-fees-state';
import * as feesActions from './fees.actions';

export const manageMemberFeeKey = 'memberFees';

export const memberFeeListInitialState: MemberFeesState = {
    isLoaded: false,
    isLoading: false,
    memberFees: []
};

export const manageMemberFeeReducer = createReducer(memberFeeListInitialState,
    on (feesActions.listMemberFeesHash, (state) => ({
        ...state,
        isLoading: true,
        isLoaded: false
    })),
    on (feesActions.listMemberFeesHashSuccess, (state, response) => ({
        ...state,
        isLoading: false,
        isLoaded: true,
        memberFees: response.listMemberFees
    })),
    on (feesActions.resetListMemberFeesHash, (state) => ({
        ...state,
        isLoading: false,
        isLoaded: false,
        memberFees: []
    }))
);
